import Spinner from "react-bootstrap/Spinner";

type Props = {
  text: string;
};

const AnalyzingLoader = ({ text }: Props) => (
  <span className="d-flex align-items-center">
    <Spinner animation="border" size="sm" variant="primary" className="me-5" />
    <b>{text}</b>
  </span>
);
export default AnalyzingLoader;
